class PayUService {
  pay({ payuDetails }) {
    const form = document.createElement("form");

    form.method = "POST";
    form.action = "https://secure.payu.in/_payment";

    Object.entries(payuDetails).forEach(([key, value]) => {
      const input = document.createElement("input");

      input.type = "hidden";
      input.name = key;
      input.value = value;

      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }
}

export default PayUService;
